import { jsxs, jsx } from "react/jsx-runtime";
const IconBoldSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.909 11.08A4.95 4.95 0 0 0 19 8c0-2.757-2.243-5-5-5H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h8.259A5.248 5.248 0 0 0 20 15.759v-.518c0-1.703-.83-3.203-2.091-4.161ZM8 6h6c1.103 0 2 .897 2 2s-.897 2-2 2H8V6Zm9 9.759A2.244 2.244 0 0 1 14.759 18H8v-5h6.759A2.244 2.244 0 0 1 17 15.241v.518Z" })
    ]
  }
);
export {
  IconBoldSvg
};
